import React from 'react';
import VisitDatePicker from '../../molecules/VisitDatePicker';
import VisitTimeReport from '../../molecules/VisitTimeReport';
import { VisitReservationSummaryInfo } from '../../../redux/reducers/VisitReservationInfoReducer';
import AdvancePreparation from '../AdvancePreparation';
import ReservationCount from '../ReservationCount';
import VisitStoreNotSelectedMessage from '../VisitStoreNotSelectedMessage';
import { MasterInfoState } from '../../../redux/reducers/MasterInfoReducer';
import { IOS_VERSIONS, isAvailableIOSVersion } from '../../../utils/UserAgent';

interface VisitSummaryProps {
  visitReservationSummaryInfo: VisitReservationSummaryInfo;
  availableStoreCnt: number;
  masterInfo: MasterInfoState;
  targetStore: string;
  targetDate: Date;
  inquiryDate: Date;
  isPastDay: boolean;
  updateTargetDate: (targetDate: Date) => void;
  isShowVisitSelectStoreModal: boolean;
}

const VisitSummary: React.FC<VisitSummaryProps> = ({
  visitReservationSummaryInfo,
  availableStoreCnt,
  masterInfo,
  targetStore,
  targetDate,
  inquiryDate,
  isPastDay,
  updateTargetDate,
  isShowVisitSelectStoreModal,
}) => {
  // グラフ表示判定
  const isViewGraph = isAvailableIOSVersion(IOS_VERSIONS.CHARTJS_IOS_VERSION_UNDER);

  return targetStore ? (
    <div className='container u-overflow-auto u-h-full'>
      {/* 日付選択部分 */}
      <VisitDatePicker className='u-mh16' value={targetDate} inquiryDate={inquiryDate} updateDate={updateTargetDate} />
      <div className='u-flex u-flex-wrap visit-summary'>
        {/* 予約数 */}
        <ReservationCount
          onlineReservationlist={visitReservationSummaryInfo.onlineReservationlist || []}
          crewReservationlist={visitReservationSummaryInfo.crewReservationlist || []}></ReservationCount>
        {/* 予約数 ここまで */}

        {/* 事前準備 */}
        <AdvancePreparation
          befCalllist={visitReservationSummaryInfo.befCalllist || []}
          advancePreparationCrewHearinglist={visitReservationSummaryInfo.advancePreparationCrewHearinglist || []}
          advancePreparationInquirylist={visitReservationSummaryInfo.advancePreparationInquirylist || []}
          lineContactList={visitReservationSummaryInfo.lineContactList || []}
          isPastDay={isPastDay}
          masterInfo={masterInfo}></AdvancePreparation>
        {/* 事前準備 ここまで */}
      </div>

      {
        /* レポート */
        isViewGraph && (
          <VisitTimeReport
            crewCountList={visitReservationSummaryInfo.reportCrewList || []}
            webCountList={visitReservationSummaryInfo.reportWebList || []}
          />
        )
      }
    </div>
  ) : (
    <VisitStoreNotSelectedMessage
      masterInfo={masterInfo}
      availableStoreCnt={availableStoreCnt}
      isShowVisitSelectStoreModal={isShowVisitSelectStoreModal}
    />
  );
};

export default VisitSummary;
